export default function AboutSection() {
  const stats = [
    { value: '99%', label: 'Uptime' },
  ];

  return (
    <section id="about" className="py-24 md:py-32 bg-[#F7F7F5]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
          {/* Left: Image */}
          <div className="w-full lg:w-[45%] flex-shrink-0">
            <div className="relative rounded-3xl overflow-hidden w-full h-[420px] md:h-[520px]">
              <img
                src="https://public.readdy.ai/ai/img_res/f347b2086fbb8ba7b81db9e467433b93.jpg"
                alt="AMIK P.C. Team"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent" />
              {/* Floating badge */}
              <div className="absolute bottom-6 left-6 bg-white rounded-2xl px-5 py-3 shadow-lg">
                <p className="text-xs text-gray-500 font-medium tracking-wide uppercase mb-0.5">Founded in</p>
                <p className="text-2xl font-extrabold text-gray-900">Athens, GR</p>
              </div>
            </div>
          </div>

          {/* Right: Content */}
          <div className="w-full lg:w-[55%]">
            <p className="text-xs font-semibold tracking-widest text-emerald-600 uppercase mb-4">( About the Team )</p>
            <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 leading-tight mb-6">
              A Team of Experts<br />
              <span className="italic font-light text-gray-400">Built for Mobile</span>
            </h2>
            <blockquote className="border-l-4 border-emerald-400 pl-6 mb-8">
              <p className="text-gray-600 text-base md:text-lg leading-relaxed">
                &ldquo;At AMIK P.C., we are passionate about crafting iOS applications that make a real difference. Our team combines deep technical expertise with a user-first mindset to deliver products that are fast, secure, and intuitive. Every line of code we write is driven by a commitment to excellence and a desire to improve the digital lives of our users.&rdquo;
              </p>
              <footer className="mt-4 text-sm font-bold text-gray-800">— AMIK P.C., Athens</footer>
            </blockquote>

            {/* Stats grid */}
            <div className="grid grid-cols-1 gap-4 max-w-[160px]">
              {stats.map((stat) => (
                <div key={stat.label} className="bg-white rounded-2xl p-4 text-center">
                  <p className="text-2xl font-extrabold text-gray-900">{stat.value}</p>
                  <p className="text-xs text-gray-500 mt-1 font-medium">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
